import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Get_PEOPLE_CODE } from '../../store/Lookup/lookupSlice';
import { useTranslation } from 'react-i18next';

const useLookupPeopleCode = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const { PEOPLE_CODE, loading, error } = useSelector((state) => state.Lookup);

  useEffect(() => {
    if (!PEOPLE_CODE || PEOPLE_CODE?.length === 0) {
      dispatch(Get_PEOPLE_CODE());
    }
  }, [PEOPLE_CODE, dispatch]);

  const OptionsPeopleCode =
    PEOPLE_CODE &&
    PEOPLE_CODE?.map((item, idx) =>
      item.list?.map((list) => ({
        value: list.lookupCode,
        label: i18n.language === 'ar' ? list.meaning2 : list.meaning,
      }))
    ).flat();

  return { Get_PEOPLE_CODE, OptionsPeopleCode, loading, error };
};

export default useLookupPeopleCode;
